<template>
  <b-container class="login-wrapper" fluid>
    <b-row>
      <b-col
        class="vh-100 login-wrapper--left w-50 d-none d-sm-none d-md-block"
      >
        <landing-page half="true" />
      </b-col>
      <b-col class="vh-100 login-wrapper--right w-50">
        <slot name="form" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LandingPage from '../Auth/LandingPage'

export default {
  name: 'MainAuthLayout',
  components: {
    LandingPage,
  },
}
</script>

<style lang="scss" scoped></style>
